import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/lib/supabase";

export interface FooterLink {
  id: number;
  label: string;
  url: string;
  seccion: "acceso_directo" | "sitios_interes";
  orden: number;
  activo: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface FooterData {
  descripcion: string;
  direccion: string;
  email: string;
  web: string;
  rut: string;
  telefono: string;
  financiador_logo?: string;
  ejecutor_logo?: string;
  copyright: string;
}

export function useFooter(fallback?: FooterData) {
  const [data, setData] = useState<FooterData | null>(null);
  const [links, setLinks] = useState<FooterLink[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [footerRes, linksRes] = await Promise.all([
        supabase.from("footer").select("*").limit(1).maybeSingle(),
        supabase
          .from("footer_links")
          .select("*")
          .eq("activo", true)
          .order("orden", { ascending: true }),
      ]);

      if (footerRes.data) {
        setData(footerRes.data as FooterData);
      } else if (fallback) {
        setData(fallback);
      }

      if (linksRes.data) {
        setLinks(linksRes.data as FooterLink[]);
      }
    } catch (err: any) {
      setError(err.message || "Error loading footer data");
      if (fallback) setData(fallback);
    } finally {
      setLoading(false);
    }
  }, [fallback]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, links, loading, error, refetch: fetchData };
}